import { render, staticRenderFns } from "./register-store.vue?vue&type=template&id=6331b898&scoped=true&"
import script from "./register-store.vue?vue&type=script&lang=js&"
export * from "./register-store.vue?vue&type=script&lang=js&"
import style0 from "@/assets/sass/bootstrap4.css?vue&type=style&index=0&id=6331b898&scoped=true&lang=css&"
import style1 from "@/assets/sass/home.css?vue&type=style&index=1&id=6331b898&scoped=true&lang=css&"
import style2 from "./register.scss?vue&type=style&index=2&id=6331b898&scoped=true&lang=scss&"
import style3 from "./register-store.vue?vue&type=style&index=3&id=6331b898&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6331b898",
  null
  
)

export default component.exports